import {
    chakra,
    Flex,
    Text
} from '@chakra-ui/react';

export const BadgeContainer = chakra(Flex, {
    label: 'ThreeEssentialsBadge_Container',
    baseStyle: {
        w: '548px',
        h: '150px',
        borderRadius: '20px',
        border: '1px solid',
        borderColor: 'primary.400',
        padding: '20px',
        gap: '20px',
        backgroundColor: '#fff',
        m: '12px',
        cursor: 'pointer',
        _hover: {
            transition: '0.2s ease',
            background: 'primary.50'
        }
    }
});

export const IconContainer = chakra(Flex, {
    label: 'ThreeEssentialsBadge_IconContainer',
    baseStyle: {
        w: '50px',
        mr: '20px'
    }
});

export const IconSvg = chakra(Flex, {
    label: 'ThreeEssentialsBadge - IconSvg',
    baseStyle: {
        justifyContent: 'center',
        bg: 'primary.50',
        minW: '60px',
        h: '60px',
        backgroundColor: 'primary.25',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'visible',
        ['svg, svg path']: {
            fill: 'var(--3p-colors-primary-500) !important',
            stroke: 'var(--3p-colors-primary-500) !important'
        }
    }
});

export const Title = chakra(Text, {
    label: 'ThreeEssentialsBadge_Title',
    baseStyle: {
        fontSize: '22px',
        fontWeight: 500,
        color: 'neutral.900',
        lineHeight: '16.56px'
    }
});

export const Description = chakra(Text, {
    label: 'ThreeEssentialsBadge_Description',
    baseStyle: {
        fontSize: '16px',
        fontWeight: 400,
        color: 'neutral.700',
        lineHeight: '24px',
        m: '12px 0'
    }
});
